import { render, staticRenderFns } from "./OwnerDash.vue?vue&type=template&id=4cd729f9&scoped=true&"
import script from "./OwnerDash.vue?vue&type=script&lang=js&"
export * from "./OwnerDash.vue?vue&type=script&lang=js&"
import style0 from "./OwnerDash.vue?vue&type=style&index=0&id=4cd729f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd729f9",
  null
  
)

export default component.exports